import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Drawer, Text, Group, Box, Card, useMantineTheme, Button, Checkbox, Timeline, Textarea, ActionIcon } from '@mantine/core';
import { IconPencil, IconCircleCheck, IconArrowLeft } from '@tabler/icons-react';

import { useLoginContext } from "../../../context/loginContext";
import { BE_API_ONE, utils } from "../../../utils/globalVariables";
import { sqlDateToHumanDate, stringDivider, safeValue, getObjectParam2 } from "../../../utils/globalFunctions";

import ModalResponse from "../../../components/general/ModalResponse";
import ModalTakeAction from "../../../components/general/ModalTakeAction";
import LabelContentInline from "../../../components/general/LabelContentInline";

const ReminderProjectSelected = ({
  stateShow,
  fnShow,
  stateData,
  stateTriggerUpdate,
  fnUpdateIndex
}) => {

  const mountedRef = React.useRef(true);
  const { loginContext, handleSetLoginContext } = useLoginContext();
  const theme = useMantineTheme();

  const notificationId = React.useRef({
    errorGetData: 'ReminderProjectSelected-1',

    successSubmit: 'ReminderProjectSelected-2',
    errorSubmit: 'ReminderProjectSelected-3',
  })

  const [data, setData] = React.useState({
    data: [],
    dataFlag: 'idle',
    dataInitLoading: false,
    dataRefresh: new Date(),

    dataMaster: null,
    dataDetil: [],

    detilModal: false,
    detilModalId: '',
    detilModalTglReminder: '',
    detilModalIsDone: false,
    detilModalKet: '',

    submitLoadingStatus: false,
    submitLoadingKet: false,
    submitLoading: false,

    modalResponse: {
      show: false,
      type: utils.modalResponse.warning,
      hideOnClickOutSide: false,
      content: ''
    }
  })

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  React.useEffect(() => {
    if (stateShow) {
      setData(d => ({ ...d, dataInitLoading: true }));

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('project_id', stateData.data.project_id);

      formDT.append('maintenance_flag', utils.projectType.maintenance.value);
      formDT.append('step_sudah_diambil_flag', utils.projectProcess.sudah_diambil.value);

      formDT.append('project_process_sudah_diambil', utils.projectProcess.nota.value);
      formDT.append('project_is_cancel', '0');

      axios({
        method: 'post',
        url: BE_API_ONE + '/get_reminder_maintenance_detil',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, dataInitLoading: false }));

        if (response.data.flag_status === 'isset') {
          setData(d => ({
            ...d,
            data: response.data.data,
            dataFlag: response.data.data.length > 0 ? true : false,

            dataMaster: Array.isArray(response.data.data_master) && (response.data.data_master.length > 0) ?
              {
                ...d.dataMaster,
                projectId: response.data.data_master[0]['project_id'],
                projectStatus: response.data.data_master[0]['project_process'],

                tanggalNota: response.data.data_master[0]['tanggal_nota'],
                tanggalSelesai: response.data.data_master[0]['tanggal_selesai'],
                tanggalAmbil: response.data.data_master[0]['tanggal_ambil'],
                remindIn: response.data.data_master[0]['remind_in_month'],

                customerName: response.data.data_master[0]['customer_name'],
                customerCategoryName: response.data.data_master[0]['customer_category_name'],

                barangCategoryName: response.data.data_master[0]['barang_category_name'],
                barangName: response.data.data_master[0]['barang_nama'],
                barangKeluhan: response.data.data_master[0]['barang_keluhan'],
              }
              :
              null,

            dataDetil: Array.isArray(response.data.data) && (response.data.data.length > 0) ?
              response.data.data.map(item => {
                return {
                  reminder_id: item.reminder_id,
                  tanggal_reminder: item.tanggal_reminder,
                  flag_done_permanent: item.flag_done,
                  flag_done_variable: item.flag_done,
                  keterangan: item.keterangan
                };
              })
              :
              []
          }));
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorGetData,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        // if (response.data.flag_status === 'no-data') {
        //     setData(d => ({
        //         ...d,
        //         projectDataFlag: false
        //     }));
        // }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({
          ...d,
          dataInitLoading: false
        }))

        notifications.show({
          id: notificationId.current.errorGetData,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }, [handleSetLoginContext, loginContext, loginContext.syswebapp, stateData.data, stateShow, data.dataRefresh, stateTriggerUpdate])

  const handleDetilState = () => {
    setData(d => ({
      ...d,
      dataDetil: d.dataDetil.map(item =>
        item.reminder_id === d.detilModalId ?
          {
            ...item,
            keterangan: d.detilModalKet ? d.detilModalKet : '',
            flag_done_variable: d.detilModalIsDone
          }
          :
          item
      ),
      detilModal: false
    }))
  }

  const handleSubmit = () => {
    setData(d => ({ ...d, submitLoading: true }));

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('project_id', Array.isArray(data.dataMaster) ? data.dataMaster.projectId : '');
    formDT.append('detil', JSON.stringify(data.dataDetil));

    formDT.append('maintenance_flag', utils.projectType.maintenance.value);
    formDT.append('step_sudah_diambil_flag', utils.projectProcess.sudah_diambil.value);

    axios({
      method: 'post',
      url: BE_API_ONE + '/update_reminder_maintenance_detil',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, submitLoading: false }));

      if (response.data.flag_status === 'isset') {
        fnShow(false);
        fnUpdateIndex(response.data.data);
      }

      if (response.data.flag_status === 'error') {
        notifications.show({
          id: notificationId.current.errorSubmit,
          title: utils.notification.warning.caption,
          message: response.data.pesan,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      }

      if (response.data.flag_status === 'no-data') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Data tidak ditemukan. Muat ulang halaman untuk mendapatkan data terbaru.',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, submitLoading: false }));

      notifications.show({
        id: notificationId.current.errorSubmit,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: false,
      })
    })
  }

  return (
    <React.Fragment>
      <Drawer.Root
        opened={stateShow}
        onClose={() => fnShow(false)}
        closeOnClickOutside
        size='md'
        // zIndex={201}
        position="left"
      >
        <Drawer.Overlay />

        <Drawer.Content>
          <Drawer.Header>
            <Drawer.Title
              sx={{
                fontWeight: 'bold',
                textTransform: 'uppercase'
              }}
            >
              <Group noWrap spacing='xs'>
                <ActionIcon
                  size='lg'
                  variant="light"
                  radius='xl'
                  color="blue"
                  onClick={() => fnShow(false)}
                >
                  <IconArrowLeft size='1.25rem' stroke={1.5} />
                </ActionIcon>

                <Text>Reminder Maintenance</Text>
              </Group>
            </Drawer.Title>
          </Drawer.Header>

          <Drawer.Body sx={{ minHeight: '100%' }}>
            {data.dataInitLoading &&
              <Group position='center'>
                <Text color='dimmed' size='sm'>Loading..</Text>
              </Group>
            }

            {(data.dataMaster !== null) && !data.dataInitLoading &&
              <Box
                mt='md'
                mb='xs'
              >
                <Text size="sm">
                  <LabelContentInline
                    stateColLabel={4}
                    stateLabel='Customer'
                    stateContent={
                      <React.Fragment>
                        <Text size="sm" fw={500} lineClamp={1}>
                          {data.dataMaster.customerName}
                        </Text>

                        <Text size="xs" lineClamp={1} color='dimmed'>
                          {data.dataMaster.customerCategoryName}
                        </Text>
                      </React.Fragment>
                    }
                    stateDivider={true}
                  />

                  <LabelContentInline
                    stateColLabel={4}
                    stateLabel='Nomor Nota'
                    stateContent={
                      <React.Fragment>
                        <Text>
                          {stringDivider(data.dataMaster.projectId, [4, 6, 8], '.', '[Nomor Nota]')}
                        </Text>

                        <Text size="xs" color='dimmed'>
                          {getObjectParam2(utils.projectProcess, data.dataMaster.projectStatus, 'caption', ' - ')}
                        </Text>
                      </React.Fragment>
                    }
                    stateDivider={true}
                  />

                  <LabelContentInline
                    stateColLabel={4}
                    stateLabel='Barang'
                    stateContent={
                      <Box>
                        {data.dataMaster.barangCategoryName ?
                          <Text lineClamp={1}>
                            {safeValue(data.dataMaster.barangCategoryName, '[Kategori Barang]')}
                          </Text>
                          :
                          <Text lineClamp={1} color='dimmed'>
                            [Kategori Barang]
                          </Text>
                        }

                        {data.dataMaster.barangName ?
                          <Text lineClamp={1}>
                            {safeValue(data.dataMaster.barangName, '[Nama Barang]')}
                          </Text>
                          :
                          <Text lineClamp={1} color='dimmed'>
                            [Nama Barang]
                          </Text>
                        }

                        {data.dataMaster.barangKeluhan ?
                          <Text lineClamp={1}>
                            {safeValue(data.dataMaster.barangKeluhan, '[Keluhan]')}
                          </Text>
                          :
                          <Text lineClamp={1} color='dimmed'>
                            [Keluhan]
                          </Text>
                        }
                      </Box>
                    }
                    stateDivider={true}
                  />

                  <LabelContentInline
                    stateColLabel={4}
                    stateLabel='Tanggal Nota'
                    stateContent={sqlDateToHumanDate({
                      stateDate: data.dataMaster.tanggalNota,
                      stateWithTime: false,
                      stateLang: 'id',
                      stateIsShort: false,
                      stateDay: false,
                      stateDefaultValue: ' - ',
                      stateDateType: 'day'
                    })}
                    stateDivider={false}
                  />

                  <LabelContentInline
                    stateColLabel={4}
                    stateLabel='Tanggal Selesai'
                    stateContent={sqlDateToHumanDate({
                      stateDate: data.dataMaster.tanggalSelesai,
                      stateWithTime: false,
                      stateLang: 'id',
                      stateIsShort: false,
                      stateDay: false,
                      stateDefaultValue: ' - ',
                      stateDateType: 'day'
                    })}
                    stateDivider={false}
                  />

                  <LabelContentInline
                    stateColLabel={4}
                    stateLabel='Tanggal Ambil'
                    stateContent={sqlDateToHumanDate({
                      stateDate: data.dataMaster.tanggalAmbil,
                      stateWithTime: false,
                      stateLang: 'id',
                      stateIsShort: false,
                      stateDay: false,
                      stateDefaultValue: ' - ',
                      stateDateType: 'day'
                    })}
                    stateDivider={false}
                  />

                  <LabelContentInline
                    stateColLabel={4}
                    stateLabel='Reminder'
                    stateContent={`Tiap ${data.dataMaster.remindIn} bulan`}
                    stateDivider={false}
                  />
                </Text>
              </Box>
            }

            {Array.isArray(data.dataDetil) && (data.dataDetil.length > 0) && !data.dataInitLoading &&
              <React.Fragment>
                <Card
                  shadow=''
                  radius="md"
                  withBorder={true}
                  mt='2rem'
                  mb='3rem'

                  style={{
                    borderColor: theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.dark[7],
                    backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[0] : theme.colors.dark[6],
                  }}
                >
                  <Card.Section px='sm' py='lg'>
                    <Timeline
                      bulletSize={24}
                      lineWidth={1}
                    >
                      {Object.keys(data.dataDetil).map((key, idx) => {

                        const flagDonePermanent = Boolean(Number(data.dataDetil[key].flag_done_permanent));
                        const flagDoneVariable = Boolean(Number(data.dataDetil[key].flag_done_variable));

                        const styleDetil = !flagDonePermanent ? {
                          '&:hover': {
                            backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[1] : theme.colors.dark[7],
                            borderRadius: theme.radius.sm,
                            cursor: 'pointer'
                          }
                        } : {}

                        return (
                          <Timeline.Item
                            key={key}
                            title={
                              <Box px='6px' py='2px'>
                                {sqlDateToHumanDate({
                                  stateDate: data.dataDetil[key].tanggal_reminder,
                                  stateWithTime: false,
                                  stateLang: 'id',
                                  stateIsShort: false,
                                  stateDay: false,
                                  stateDefaultValue: ' - ',
                                  stateDateType: 'day'
                                })}
                              </Box>
                            }
                            bullet={<Text size='xs'>{Number(data.dataDetil.length) - Number(idx)}</Text>}
                            active={flagDoneVariable}
                            lineActive={flagDoneVariable}
                          >
                            <Group
                              position='apart'
                              p='6px'
                              sx={() => (styleDetil)}

                              onClick={flagDonePermanent ?
                                () => { }
                                :
                                () => {
                                  setData(d => ({
                                    ...d,
                                    detilModalId: data.dataDetil[key].reminder_id,
                                    detilModalTglReminder: data.dataDetil[key].tanggal_reminder,
                                    detilModalIsDone: flagDoneVariable,
                                    detilModalKet: data.dataDetil[key].keterangan ? data.dataDetil[key].keterangan : '',
                                    detilModal: true,
                                  }))
                                }
                              }
                            >
                              <Box>
                                <Text
                                  color="dimmed"
                                  size="sm"
                                >
                                  {flagDoneVariable ?
                                    <Group noWrap spacing='.3rem'>
                                      <Text>
                                        Sudah difollow up
                                      </Text>

                                      <IconCircleCheck size='.95rem' />
                                    </Group>
                                    :
                                    'Belum difollow up'
                                  }
                                </Text>

                                <Text
                                  size="xs"
                                  mt={2}
                                  sx={() => ({
                                    wordBreak: 'break-word',
                                  })}
                                >
                                  {!data.dataDetil[key].keterangan ? '[Catatan]' : data.dataDetil[key].keterangan}
                                </Text>
                              </Box>

                              {!flagDonePermanent &&
                                <Box>
                                  <IconPencil size='1rem' />
                                </Box>
                              }
                            </Group>
                          </Timeline.Item>
                        )
                      })}
                    </Timeline>
                  </Card.Section>
                </Card>
              </React.Fragment>
            }

            {(!data.dataMaster) && !data.dataInitLoading && (data.dataFlag !== 'idle') &&
              <Text
                color='dimmed'
                size='sm'
              >
                Tidak ada data
              </Text>
            }
          </Drawer.Body>

          {(data.dataMaster !== null) && !data.dataInitLoading &&
            <Drawer.Header
              sx={{
                position: 'sticky',
                top: 'unset',
                bottom: 0,
                right: 0,
                left: 0
              }}
            >
              <Group
                noWrap
                sx={{ width: '100%' }}
              >
                <Button
                  fullWidth
                  variant="light"
                  size="sm"
                  onClick={() => fnShow(false)}
                >
                  Close
                </Button>

                <Button
                  fullWidth
                  variant='filled'
                  size="sm"
                  loading={data.submitLoading}
                  onClick={handleSubmit}
                >
                  Simpan
                </Button>
              </Group>
            </Drawer.Header>
          }
        </Drawer.Content>
      </Drawer.Root>

      <ModalResponse
        stateShow={data.modalResponse.show}
        fnHide={() => setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            show: false
          }
        }))}

        stateOverlayZIndex={201}

        stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
        stateType={data.modalResponse.type}
        stateContent={data.modalResponse.content}
      />

      <ModalTakeAction
        stateShow={data.detilModal}
        fnHide={() => setData(d => ({ ...d, detilModal: false }))}

        stateHideOnClickOutSide={true}
        stateTitle={String('Reminder Maintenance').toUpperCase()}
        stateOverlayZIndex={201}

        stateButtonClosePx='md'

        stateButtonActionCaption='Terapkan'
        stateButtonActionPx='xs'
        stateButtonActionColor="blue"
        stateButtonActionLoading={false}
        fnButtonAction={handleDetilState}
      >
        <Checkbox
          mt='1rem'
          mb='1rem'
          label={`Reminder untuk tanggal ${sqlDateToHumanDate({
            stateDate: data.detilModalTglReminder,
            stateWithTime: false,
            stateLang: 'id',
            stateIsShort: false,
            stateDay: false,
            stateDefaultValue: ' - ',
            stateDateType: 'day'
          })} sudah di follow up`}
          description={`Bila di ceklis, reminder tanggal ${sqlDateToHumanDate({
            stateDate: data.detilModalTglReminder,
            stateWithTime: false,
            stateLang: 'id',
            stateIsShort: false,
            stateDay: false,
            stateDefaultValue: ' - ',
            stateDateType: 'day'
          })} tidak dapat diubah dan tidak akan dimunculkan lagi.`}
          checked={data.detilModalIsDone}
          onChange={(event) => setData(d => ({ ...d, detilModalIsDone: event.target.checked }))}
        />

        <Textarea
          value={data.detilModalKet}
          minRows={3}
          maxRows={4}
          onChange={(e) =>
            setData(d => ({
              ...d,
              detilModalKet: e.target.value
            }))
          }

          label='Catatan'
          placeholder='Misal: Sudah di whatsapp'
          error=''
          description=''
          withAsterisk={false}
        />
      </ModalTakeAction>
    </React.Fragment>
  )
}

export default ReminderProjectSelected;